import { render } from "./LayoutCustomObject.vue?vue&type=template&id=48ac9fba"
import script from "./LayoutCustomObject.vue?vue&type=script&lang=js"
export * from "./LayoutCustomObject.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__